<template>
  <div class="innerItem settingOrder">
    <div :class="{disabled: order.disabled}">
      <p class="innerTitle setLabel">{{locale.order}}</p>
      <div class="mb5">
        <div class="checkbox">
          <input type="checkbox" id="request_input_disabled" v-model="order.disabled">
          <label for="request_input_disabled">{{locale.order_input_disabled}}</label>
        </div>
      </div>
      <div class="mt5">
        <button type="button" class="addUserinfo btn btnWhite sizeS" @click="setUserinfo(true)">{{locale.setting_set_userinfo}}</button>
      </div>
      <div class="mt10">
        <div class="checkbox">
          <input type="checkbox" id="request_multi_cart" v-model="order.multiCart">
          <label for="request_multi_cart">{{locale.multicart_submitcode}}</label>
        </div>
      </div>
      <div class="mt10">
        <div class="checkbox">
          <input type="checkbox" id="request_progress_disabled" v-model="order.progressDisabled">
          <label for="request_progress_disabled">{{locale.setting_order_status_disabled}}</label>
        </div>
      </div>
    </div>
    <!-- 룸차지 안내문구 -->
    <div class="mt30">
      <p class="innerTitle setLabel">{{locale.roomcharge_info_input}}</p>
      <p class="sysMessage">{{locale.roomcharge_info_input_message}}</p>
      <div class="mb5">
        <div class="checkbox">
          <input type="checkbox" id="request_roomcharge_info" v-model="order.roomChargeMsgActive">
          <label for="request_roomcharge_info">{{locale.enabled}}</label>
        </div>
      </div>
      <div>
        <SetLanguageValue
          :locale="locale"
          :langValue="order.roomChargeMsg" />
      </div>
    </div>
    <!-- //룸차지 안내문구 -->
    <!-- 주문자 입력 정보 커스텀 -->
    <SetUserinfo
      v-if="userinfoLayer"
      :locale="locale"
      :userinfo="userinfo"
      @close="setUserinfo(false)"
      @apply="applyUserinfo" />
    <!-- //주문자 입력 정보 커스텀 -->
  </div>
</template>

<script>
import regExp from '@/common/regExp'
import SetLanguageValue from '@/components/Util/SetLanguageValue'
import SetUserinfo from '@/components/Util/SetUserinfo.vue'
import UTIL from '@/common/util'

export default {
  name: 'SetOrder',
  props: [
    'locale',
    'order',
    'lang'
  ],
  components: {
    SetLanguageValue,
    SetUserinfo
  },
  computed: {
  },
  data () {
    return {
      layer: false,
      langValue: {},
      tipValue: '',
      userinfoLayer: false,
      userinfo: {}
    }
  },
  methods: {
    setUserinfo (isOpen) {
      const userinfo = {
        firstName: this.order.firstName === false ? this.order.firstName : true,
        lastName: this.order.lastName === false ? this.order.lastName : true,
        email: this.order.email,
        tel: this.order.tel
      }
      const customUserinfos = Object.keys(this.order).filter(x => x.startsWith('custom')).map(x => this.order[x])
      function arrToObj (arr) {
        const result = {}
        for (let i = 0; i < arr.length; i++) {
          const id = arr[i].id
          result[id] = arr[i]
        }
        return result
      }
      this.userinfo = {
        ...userinfo,
        ...arrToObj(customUserinfos)
      }
      this.userinfoLayer = isOpen
    },
    applyUserinfo (data) {
      const order = Object.keys(this.order).filter(key =>
        !key.startsWith('custom_')).reduce((obj, key) => {
        obj[key] = this.order[key]
        return obj
      }, {}
      )
      const result = {
        ...order,
        ...data
      }
      this.$store.commit('setting/setOrder', result)
    },
    setDefaultVal (key) {
      const defaultLang = this.lang.default
      const target = this.order[key]
      const fillLangs = UTIL.fillLangs(target, target[defaultLang])
      this.order[key] = fillLangs
    },
    onLanguageLayerOpen (key) {
      this.langValue = this.order[key]
      this.layer = true
    },
    onLanguageLayerClose () {
      this.langValue = {}
      this.layer = false
    },
    inputNumber (key) {
      if (key === 'tipValue') {
        const value = regExp.numberOnly(this.tipValue)
        this.tipValue = value
      } else {
        const value = regExp.numberOnly(this.order[key])
        this.order[key] = value
      }
    },
    addTip () {
      const value = regExp.replaceAllEmpty(this.tipValue)
      const tips = this.order.tip || []
      if (value.length && !tips.includes(value)) {
        this.order.tip = tips.concat(value)
        this.tipValue = ''
      }
    },
    delTip (index) {
      if (window.confirm(this.locale.confirm_delete)) {
        this.order.tip = this.order.tip.filter((x, i) => i !== index)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.disabled {
  .checkOption {
    opacity: 0.5;
  }
}
.btnTip {
  position: relative;
  margin-top: 10px;
  margin-right: 10px;
  padding-left: 15px;
  border-radius: 2px;
  .btnDel {
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 20px;
    margin-top: -5px;
    margin-right: -5px;
    border-radius: 100%;
    background-color: $color-lgrey;
    &:before,
    &:after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 10px;
      height: 1px;
      margin-left: -5px;
      background-color: $color-white;
      transform: rotate(45deg);
    }
    &:after {
      transform: rotate(-45deg);
    }
  }
}
</style>
